import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {isUndefined} from "util";
import {WatchService} from "../../services/watch.service";
import {Subject} from "rxjs/Subject";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";

@Component({
  selector: 'nv-ad-nets',
  templateUrl: './nv-ad-nets.component.html',
  styles: []
})
export class NvAdNetsComponent implements OnInit, OnDestroy {

  @Input() title:string;
  @Input() document:any;
  netToAdd:string='UnityAds';
  loadedNetsList:any[] = [
    {name:"UnityAds"},
    {name:"AdMob"},
    {name:"Facebook"}
  ]

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private watchService:WatchService,
              private collectionService:CollectionService) { }

  ngOnInit() {
    this.loadNetsList();
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  loadNetsList(){
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.AD_NETWORK).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .takeUntil(this.unsubscribe)
      .subscribe(r => {
        this.loadedNetsList = r.documents;
        if (this.loadedNetsList.length > 0)
        {
          this.netToAdd = this.loadedNetsList[0].name;
        }
      });
  }


  onAddClick() {
    if (isUndefined(this.document.nets))
    {
      this.document.nets = [];
    }
    if (this.document.nets.indexOf(this.netToAdd) < 0)
    {
      this.document.nets.push(this.netToAdd);
      this.watchService.notify();
    }
  }

  getNetLabel(n){
    return n;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-ads-settings/nv-ad-nets.component.ts